import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfoDetailsByUserId } from "../../../store/slices/userSlice";
import { useNavigate } from "react-router-dom";
import {
  updateParentPermissions,
  updateChildPermissions,
  updateSubChildPermissions,
  getAllModulesWithPermissionSlice,
} from "../../../store/slices/roleSlice";
import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import styles from "../../components/role/roleModule.module.scss";
import { showToastifySuccess } from "../../common/tostify/Toastifyresponse";

const ModulePermissions = ({ userToken, userId }) => {
  const dispatch = useDispatch();
  const moduleRefs = useRef({});
  const { userInfoDetails } = useSelector((state) => state.users);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const { moduleRolePermissions } = useSelector((state) => state.role);
  const [searchModule, setSearchModule] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("User");
  const [permissions, setPermissions] = useState({});
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const clinicInfo = useSelector((state) => state.clinic.clinicInfo);
  const clinicId = clinicInfo[0]?.clinicId;
  useEffect(() => {
    if (userToken && userId) {
      dispatch(getUserInfoDetailsByUserId({ token: userToken, userId }));
    }
  }, [dispatch, userToken, userId]);

  useEffect(() => {
    const RoleId = sessionStorage.getItem("roleId");
    const RoleName = sessionStorage.getItem("roleName");
    setSelectedRoleName(RoleName);
    setSelectedRoleId(RoleId);
  }, []);

  useEffect(() => {
    if (selectedRoleId) {
      dispatch(
        getAllModulesWithPermissionSlice({
          roleId: selectedRoleId,
          clinicId,
          token,
        })
      );
    } else {
      setPermissions({});
    }
  }, [selectedRoleId, dispatch, token, clinicId]);

  useEffect(() => {
    if (
      moduleRolePermissions &&
      Array.isArray(moduleRolePermissions.modulePermissions) &&
      moduleRolePermissions.modulePermissions.length > 0
    ) {
      const initialPermissions = {};
      moduleRolePermissions.modulePermissions.forEach((permission) => {
        if (permission?.moduleId?._id) {
          initialPermissions[permission.moduleId._id] = {
            canView: permission.canView,
            canAdd: permission.canAdd,
            canEdit: permission.canEdit,
            canDelete: permission.canDelete,
            canExport: permission.canExport,
            moduleType: "parent",
          };
          if (
            Array.isArray(permission.childPermission) &&
            permission.childPermission.length > 0
          ) {
            permission.childPermission.forEach((childPermission) => {
              if (childPermission?.moduleId) {
                initialPermissions[childPermission.moduleId] = {
                  canView: childPermission.canView,
                  canAdd: childPermission.canAdd,
                  canEdit: childPermission.canEdit,
                  canDelete: childPermission.canDelete,
                  canExport: childPermission.canExport,
                  moduleType: "child",
                  parentModuleId: permission.moduleId._id,
                };
                if (
                  Array.isArray(childPermission.supperChildPermission) &&
                  childPermission.supperChildPermission.length > 0
                ) {
                  childPermission.supperChildPermission.forEach(
                    (superChildPermission) => {
                      if (superChildPermission?.moduleId) {
                        initialPermissions[superChildPermission.moduleId] = {
                          canView: superChildPermission.canView,
                          canAdd: superChildPermission.canAdd,
                          canEdit: superChildPermission.canEdit,
                          canDelete: superChildPermission.canDelete,
                          canExport: superChildPermission.canExport,
                          moduleType: "superChild",
                          parentModuleId: permission.moduleId._id,
                          childModuleId: childPermission.moduleId,
                        };
                      }
                    }
                  );
                }
              }
            });
          }
        }
      });
      setPermissions(initialPermissions);
    } else {
      setPermissions({});
    }
  }, [moduleRolePermissions]);

  const handleCheckboxChange = async (moduleId, permissionType, isChecked, level, parentId = null, childId = null) => {
    const permissionData = {
      roleId: selectedRoleId,
      moduleId,
      permissions: { [permissionType]: isChecked },
      token
    };
    try {
      if (level === "module") {
        await dispatch(updateParentPermissions(permissionData)).unwrap();
      } else if (level === "child") {
        await dispatch(
          updateChildPermissions({
            ...permissionData,
            clinicId,
            parentId,
            token
          })
        ).unwrap();
      } else if (level === "subChild") {
        await dispatch(
          updateSubChildPermissions({
            ...permissionData,
            clinicId,
            parentId,
            childId,
            token
          })
        ).unwrap();
      }
      dispatch(
        getAllModulesWithPermissionSlice({
          clinicId,
          roleId: selectedRoleId,
          token
        })
      );
    } catch (error) {
      console.error("Error updating permissions:", error);
    }
    setPermissions((prevPermissions) => {
      const updatedPermissions = { ...prevPermissions };
      if (level === "module") {
        updatedPermissions[moduleId] = {
          ...updatedPermissions[moduleId],
          [permissionType]: isChecked,
        };
      } else if (level === "child") {
        updatedPermissions[parentId].childMenu = updatedPermissions[
          parentId
        ].childMenu?.map((child) =>
          child?.moduleId === moduleId
            ? { ...child, [permissionType]: isChecked }
            : child
        );
      } else if (level === "subChild") {
        updatedPermissions[parentId].childMenu = updatedPermissions[
          parentId
        ].childMenu?.map((child) =>
          child?.moduleId === childId
            ? {
              ...child,
              subChildMenu: child?.subChildMenu?.map((subChild) =>
                subChild?.moduleId === moduleId
                  ? { ...subChild, [permissionType]: isChecked }
                  : subChild
              ),
            } : child
        );
      }
      return updatedPermissions;
    });
  };
  const handleSavePermissions = () => {
    showToastifySuccess("Permissions have been updated successfully.");
  };

  const handleSearchModule = (e) => {
    const value = e.target.value;
    setSearchModule(value);

    const filteredSuggestions = userInfoDetails?.filter((module) =>
      module.parentModule.title
        .toLowerCase()
        .includes(value.toLowerCase())
    );

    setSearchSuggestions(filteredSuggestions || []);
  };

  const handleCancelSuggestions = () => {
    setSearchModule("");
    setSearchSuggestions([]);
  };
  //suggestion scrrol issue fixed
  const handleSuggestionClick = (suggestion) => {
    const moduleId = suggestion.parentModule._id;

    setSearchModule(suggestion.parentModule.title);
    setSearchSuggestions([]);

    setTimeout(() => {
      const element = moduleRefs.current[moduleId];
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }
    }, 100);
  };
  const handleGoBackClick = () => {
    navigate("/role");
  };

  const hasParentPermission = (parentId) => {
    const parentPermissions = permissions[parentId];
    return (
      parentPermissions?.canView ||
      parentPermissions?.canAdd ||
      parentPermissions?.canEdit ||
      parentPermissions?.canDelete ||
      parentPermissions?.canExport
    );
  };
  const hasChildPermission = (childId) => {
    const childPermissions = permissions[childId];
    return (
      childPermissions?.canView ||
      childPermissions?.canAdd ||
      childPermissions?.canEdit ||
      childPermissions?.canDelete ||
      childPermissions?.canExport
    );
  };

  return (
    <div>
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleSavePermissions}
      >
        Save Permissions For {selectedRoleName}
      </button>

      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="input-group search-area ms-auto d-inline-flex me-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search Modules"
            value={searchModule}
            onChange={handleSearchModule}
          />
          {searchSuggestions?.length > 0 || searchModule ? (
            <div className={styles["search-suggestions"]}>
              <div className={styles["suggestion-header"]}>
                <h6>Suggestions</h6>
                <span
                  className={styles["cancel-icon"]}
                  onClick={handleCancelSuggestions}
                >
                  <RxCross2 />
                </span>
              </div>
              {searchModule && searchSuggestions?.length === 0 ? (
                <div className={styles["no-results-found"]}>
                  <p>No modules found</p>
                </div>
              ) : (
                searchSuggestions?.map((suggestion, idx) => (
                  <div
                    key={idx}
                    className={styles["suggestion-item"]}
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion.parentModule.title}
                  </div>
                ))
              )}
            </div>
          ) : null}

          <div className="input-group-append">
            <button type="button" className="input-group-text">
              <FaSearch className="flaticon-381-search-2" />
            </button>
          </div>
        </div>
        <button className="btn btn-primary" onClick={handleGoBackClick}>
          Back to list
        </button>
      </div>

      {userInfoDetails?.map((module) => (
        //changes
        <div
          key={module.parentModule._id}
          ref={(el) => (moduleRefs.current[module.parentModule._id] = el)}
          className={styles["accordion-body"]}
        >
          <table className="table">
            <thead>
              <tr>
                <th>Module Name</th>
                <th>View</th>
                <th>Add</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>Export</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{module.parentModule.title}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[module.parentModule._id]?.canView}
                    disabled={!module.canView}
                    onChange={(e) =>
                      handleCheckboxChange(
                        module.parentModule._id,
                        "canView",
                        e.target.checked,
                        "module"
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[module.parentModule._id]?.canAdd}
                    disabled={!module.canAdd}
                    onChange={(e) =>
                      handleCheckboxChange(
                        module.parentModule._id,
                        "canAdd",
                        e.target.checked,
                        "module"
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[module.parentModule._id]?.canEdit}
                    disabled={!module.canEdit}
                    onChange={(e) =>
                      handleCheckboxChange(
                        module.parentModule._id,
                        "canEdit",
                        e.target.checked,
                        "module"
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[module.parentModule._id]?.canDelete}
                    disabled={!module.canDelete}
                    onChange={(e) =>
                      handleCheckboxChange(
                        module.parentModule._id,
                        "canDelete",
                        e.target.checked,
                        "module"
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[module.parentModule._id]?.canExport}
                    disabled={!module.canExport}
                    onChange={(e) =>
                      handleCheckboxChange(
                        module.parentModule._id,
                        "canExport",
                        e.target.checked,
                        "module"
                      )
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
          {module?.childModules?.map((childModule, j) => (
            <div
              // key={j}
              // id={child-${i}-${j}}
              // ref={(el) => (childRefs.current[${i}-${j}] = el)}
              className={styles["accordion-body2"]}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>Module Name</th>
                    <th>View</th>
                    <th>Add</th>
                    <th>Edit</th>
                    <th>Delete</th>
                    <th>Export</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="child-module-row">
                    <td>{childModule.title}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[childModule._id]?.canView || false}
                        disabled={!childModule.canView || !hasParentPermission(module.parentModule._id)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            childModule._id,
                            "canView",
                            e.target.checked,
                            "child",
                            module.parentModule._id
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[childModule._id]?.canAdd || false}
                        disabled={
                          !childModule.canAdd || !hasParentPermission(module.parentModule._id)
                        }
                        onChange={(e) =>
                          handleCheckboxChange(
                            childModule._id,
                            "canAdd",
                            e.target.checked,
                            "child",
                            module.parentModule._id
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[childModule._id]?.canEdit || false}
                        disabled={!childModule.canEdit || !hasParentPermission(module.parentModule._id)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            childModule._id,
                            "canEdit",
                            e.target.checked,
                            "child",
                            module.parentModule._id
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          permissions[childModule._id]?.canDelete || false
                        }
                        disabled={!childModule.canDelete || !hasParentPermission(module.parentModule._id)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            childModule._id,
                            "canDelete",
                            e.target.checked,
                            "child",
                            module.parentModule._id
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          permissions[childModule._id]?.canExport || false
                        }
                        disabled={!childModule.canExport || !hasParentPermission(module.parentModule._id)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            childModule._id,
                            "canExport",
                            e.target.checked,
                            "child",
                            module.parentModule._id
                          )
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              {childModule?.subChildModules?.map((subChildModule, k) => (
                <div
                  // id={subchild-${i}-${j}-${k}}
                  // ref={(el) => (subChildRefs.current[${i}-${j}-${k}] = el)}
                  className={styles["accordion-body3"]}
                >
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Module Name</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                        <th>Export</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="sub-child-module-row">
                        <td>{subChildModule.title}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={
                              permissions[subChildModule?._id]?.canView || false
                            }
                            disabled={!subChildModule.canView || !hasParentPermission(module.parentModule._id)
                              || !hasChildPermission(childModule._id)}

                            onChange={(e) =>
                              handleCheckboxChange(
                                subChildModule._id,
                                "canView",
                                e.target.checked,
                                "subChild",
                                module.parentModule._id,
                                childModule._id
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={
                              permissions[subChildModule?._id]?.canAdd || false
                            }
                            disabled={!subChildModule.canAdd || !hasParentPermission(module.parentModule._id)
                              || !hasChildPermission(childModule._id)}
                            onChange={(e) =>
                              handleCheckboxChange(
                                subChildModule._id,
                                "canAdd",
                                e.target.checked,
                                "subChild",
                                module.parentModule._id,
                                childModule._id
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={
                              permissions[subChildModule?._id]?.canEdit || false
                            }
                            disabled={!subChildModule.canEdit || !hasParentPermission(module.parentModule._id)
                              || !hasChildPermission(childModule._id)}
                            onChange={(e) =>
                              handleCheckboxChange(
                                subChildModule._id,
                                "canEdit",
                                e.target.checked,
                                "subChild",
                                module.parentModule._id,
                                childModule._id
                              )
                            }
                          />
                        </td>

                        <td>
                          <input
                            type="checkbox"
                            checked={
                              permissions[subChildModule?._id]?.canDelete ||
                              false
                            }
                            disabled={!subChildModule.canDelete || !hasParentPermission(module.parentModule._id)
                              || !hasChildPermission(childModule._id)}
                            onChange={(e) =>
                              handleCheckboxChange(
                                subChildModule._id,
                                "canDelete",
                                e.target.checked,
                                "subChild",
                                module.parentModule._id,
                                childModule._id
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={
                              permissions[subChildModule._id]?.canExport ||
                              false
                            }
                            disabled={!subChildModule.canExport || !hasParentPermission(module.parentModule._id)
                              || !hasChildPermission(childModule._id)}
                            onChange={(e) =>
                              handleCheckboxChange(
                                subChildModule._id,
                                "canExport",
                                e.target.checked,
                                "subChild",
                                module.parentModule._id,
                                childModule._id
                              )
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ModulePermissions;